export enum EnumType {
    IntType = 0,
    StringType = 1,
    BoolType = 2
}
